import { Directive } from '@angular/core';

@Directive({ selector: 'tr-accordion-content' })
export class TrAccordionContent {}
